module.exports = __webpack_public_path__ + "static/media/bronze.f15bde34.webp";